import config from "../../config"
import RequestService from "../RequestService"

const importReservations = (id, params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrlV2}/reservation_imports/${id}`, { reservation_import: params }, successCallback, failureCallback)
}

export default importReservations;